// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!../../../node_modules/postcss-loader/dist/cjs.js!../library/style/breakpoint.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tKygQ4LMDikHs5Hsh0Qk {
  position: fixed;
  top: 16px;
  left: 0;
  right: 0;
  z-index: 1000;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 75%;
  height: 75px;
  margin: 16px auto;
  background: #fff;
  box-shadow: 0 13px 25px rgb(0 0 0 / 10%);
  border-radius: 5px;
  padding: 0 24px;
  max-width: 1440px;
}

.axQXDKRP7xWmEunVmiK_ {
  display: flex;
  flex-direction: row;
}

.tKygQ4LMDikHs5Hsh0Qk p {
  margin-right: 30px;
}

.qX0uRzHkNRV16dkXqulV {
  margin-left: auto;
}

.fUnS8BXXQeLUzup7jb9J {
  margin: 0;
  font-family: Fjalla One;
  font-style: normal;
  font-weight: normal;
  font-size: 24px;
  letter-spacing: 0.005em;
  text-transform: uppercase;
}

.in4guNdMKK7RFxjtEGuk {
    display: none;
}

.FFBV3nI5LWIsjBSs09NP {
    display: none;
}

.qufy1HKj47lFxAbelrQe {
  display: none;
}

.pUWjB59iNs8b5tX3iMwn {
  margin: 0;
}

@media screen and (max-width: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["mobile-xs"]}) {
  .fUnS8BXXQeLUzup7jb9J {
    margin-right: 16px;
  }
}

@media screen and (max-width: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["tablet-l"]}) {
  .wDeOBklC4OfGjYGrFkce {
    display: flex;
    flex-direction: row-reverse;
  }

  .axQXDKRP7xWmEunVmiK_ {
    display: none;
  }

  .tKygQ4LMDikHs5Hsh0Qk {
    width: 100%;
  }

  .RHJ9fyGU3xJGSIiej7t2 {
    margin: 0;
  }

  .in4guNdMKK7RFxjtEGuk {
    width: 100%;
    display: flex;
    justify-content: space-between;
    padding: 0 24px;
  }

  .qufy1HKj47lFxAbelrQe {
    display: flex;
  }

  .FFBV3nI5LWIsjBSs09NP {
    width: 100%;
    display: flex;
    justify-content: space-between;
  }

  .W_KiIUmbky6HAaQdN7Hu {
    background-color: #ebeefd;
    padding: 0 24px;
  }

  .tKygQ4LMDikHs5Hsh0Qk {
    width: 100%;
    box-sizing: border-box;
    flex-direction: column;
    height: unset;
    max-height: unset;
    border-radius: 0;
    padding: unset;
    width: 100%;
    top: 0;
    margin: 0;
  }

  .qX0uRzHkNRV16dkXqulV {
    margin-left: 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Navigation/Navigation.module.css"],"names":[],"mappings":"AAGA;EACE,eAAe;EACf,SAAS;EACT,OAAO;EACP,QAAQ;EACR,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,UAAU;EACV,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,wCAAwC;EACxC,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,SAAS;AACX;;AAEA;EACE;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,aAAa;IACb,2BAA2B;EAC7B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,WAAW;IACX,aAAa;IACb,8BAA8B;IAC9B,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,aAAa;IACb,8BAA8B;EAChC;;EAEA;IACE,yBAAyB;IACzB,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,sBAAsB;IACtB,sBAAsB;IACtB,aAAa;IACb,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,WAAW;IACX,MAAM;IACN,SAAS;EACX;;EAEA;IACE,cAAc;EAChB;AACF","sourcesContent":["@value breakpoints: \"../library/style/breakpoint.css\";\n@value mobile-xs, tablet-l from breakpoints;\n\n.navigation {\n  position: fixed;\n  top: 16px;\n  left: 0;\n  right: 0;\n  z-index: 1000;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  width: 75%;\n  height: 75px;\n  margin: 16px auto;\n  background: #fff;\n  box-shadow: 0 13px 25px rgb(0 0 0 / 10%);\n  border-radius: 5px;\n  padding: 0 24px;\n  max-width: 1440px;\n}\n\n.section {\n  display: flex;\n  flex-direction: row;\n}\n\n.navigation p {\n  margin-right: 30px;\n}\n\n.split {\n  margin-left: auto;\n}\n\n.logo {\n  margin: 0;\n  font-family: Fjalla One;\n  font-style: normal;\n  font-weight: normal;\n  font-size: 24px;\n  letter-spacing: 0.005em;\n  text-transform: uppercase;\n}\n\n.navigationMobile {\n    display: none;\n}\n\n.navigationMenuMobile {\n    display: none;\n}\n\n.sectionMobile {\n  display: none;\n}\n\n.buttonBuger {\n  margin: 0;\n}\n\n@media screen and (max-width: mobile-xs) {\n  .logo {\n    margin-right: 16px;\n  }\n}\n\n@media screen and (max-width: tablet-l) {\n  .grid {\n    display: flex;\n    flex-direction: row-reverse;\n  }\n\n  .section {\n    display: none;\n  }\n\n  .navigation {\n    width: 100%;\n  }\n\n  .content {\n    margin: 0;\n  }\n\n  .navigationMobile {\n    width: 100%;\n    display: flex;\n    justify-content: space-between;\n    padding: 0 24px;\n  }\n\n  .sectionMobile {\n    display: flex;\n  }\n\n  .navigationMenuMobile {\n    width: 100%;\n    display: flex;\n    justify-content: space-between;\n  }\n\n  .navigationBackGround {\n    background-color: #ebeefd;\n    padding: 0 24px;\n  }\n\n  .navigation {\n    width: 100%;\n    box-sizing: border-box;\n    flex-direction: column;\n    height: unset;\n    max-height: unset;\n    border-radius: 0;\n    padding: unset;\n    width: 100%;\n    top: 0;\n    margin: 0;\n  }\n\n  .split {\n    margin-left: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"breakpoints": `"../library/style/breakpoint.css"`,
	"mobile-xs": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["mobile-xs"]}`,
	"tablet-l": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["tablet-l"]}`,
	"navigation": `tKygQ4LMDikHs5Hsh0Qk`,
	"section": `axQXDKRP7xWmEunVmiK_`,
	"split": `qX0uRzHkNRV16dkXqulV`,
	"logo": `fUnS8BXXQeLUzup7jb9J`,
	"navigationMobile": `in4guNdMKK7RFxjtEGuk`,
	"navigationMenuMobile": `FFBV3nI5LWIsjBSs09NP`,
	"sectionMobile": `qufy1HKj47lFxAbelrQe`,
	"buttonBuger": `pUWjB59iNs8b5tX3iMwn`,
	"grid": `wDeOBklC4OfGjYGrFkce`,
	"content": `RHJ9fyGU3xJGSIiej7t2`,
	"navigationBackGround": `W_KiIUmbky6HAaQdN7Hu`
};
export default ___CSS_LOADER_EXPORT___;
